import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { OrderDetailTotalsComponent, OrderDetailsService } from '@spartacus/order/components';
import { KnBrOrderOverviewComponent } from '../../kn-br-order-overview/kn-br-order-overview.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'cx-order-confirmation-overview',
    templateUrl: './kn-br-order-confirmation-overview.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [KnBrOrderOverviewComponent, AsyncPipe]
})
// Need To Discuss
export class KnBrOrderConfirmationOverviewComponent extends OrderDetailTotalsComponent implements OnInit {
  constructor(protected orderDetailsService: OrderDetailsService) {
    super(orderDetailsService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
